import React from 'react';
import VoiceDashboard from '../components/voice/VoiceDashboard';
import VoiceAgents from '../components/voice/VoiceAgents';
import { useBranding } from '../context/BrandingContext';
import { Bot } from 'lucide-react';

const VoicePage = () => {
    const brandingContext = useBranding();
    const isFitenko = Boolean(
        brandingContext?.isFitenko ||
        brandingContext?.branding?.instance_name === 'fitenko' ||
        (typeof window !== 'undefined' && (
            window.location.hostname.includes('fitenko') ||
            localStorage.getItem('tenant_id') === 'fitenko' ||
            localStorage.getItem('lastTenant') === 'fitenko'
        ))
    );

    return (
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6 text-[#20231F]">
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 border-b border-[#E5E1D6] pb-5">
                <div>
                    <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider font-bold text-[#C8A653]">
                        <Bot className="w-3.5 h-3.5" />
                        Autonomous Voice Operations
                    </div>
                    <h1
                        className="text-2xl sm:text-3xl font-bold tracking-tight text-[#20231F] mt-1"
                        style={{ fontFamily: isFitenko ? 'DM Serif Display, Georgia, serif' : 'inherit' }}
                    >
                        AI Voice Paralegal
                    </h1>
                    <p className="text-xs sm:text-sm text-[#687077] mt-1">
                        Autonomous legal intake, call handling, live monitoring & sentiment analytics
                    </p>
                </div>
            </div>

            <div className="w-full space-y-6">
                {/* Main Analytics Dashboard */}
                <VoiceDashboard />

                {/* Admin Brain Center (Visible only for admin role) */}
                <VoiceAgents />
            </div>
        </div>
    );
};

export default VoicePage;

